export default __webpack_public_path__ + "static/media/maths3.51e321a2.png";